import Panzoom from "@panzoom/panzoom";

export default function panZoomPlan() {
  function init() {
    const elements = document.querySelectorAll(".js-panzoom-wrap");

    elements.forEach((el) => {
      const plan = el.querySelector(".js-panzoom-el");

      const panzoom = Panzoom(plan, {
        // maxScale: 10,
        // step: 0.2,
        // contain: 'outside',
        startScale: window.innerWidth < 768 ? 0.75 : 1,
      });

      const btnIn = el.querySelector(".js-panzoom-in");
      const btnOut = el.querySelector(".js-panzoom-out");
      const btnReset = el.querySelector(".js-panzoom-reset");

      btnIn.addEventListener("click", panzoom.zoomIn);
      btnOut.addEventListener("click", panzoom.zoomOut);
      btnReset.addEventListener("click", panzoom.reset);
    });
  }

  const isPresent = document.getElementsByClassName("js-panzoom-wrap");
  if (isPresent.length > 0) {
    init();
  }
}
